import { createFileRoute } from "@tanstack/react-router";

import { ConnectedAppsTab } from "@/features/wonda/components/ConnectedAppsTab";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/connected-apps",
)({
  component: ConnectedAppsTab,
});
